module.exports = __webpack_public_path__ + "static/media/LogoPNG.91fa52a3.png";